import React from 'react';
import DriverCard from "./DriverCard";
import DriverTransport from "./DriverTransport";

export default {
  DriverCard,
  DriverTransport
};